var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapacitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47375 10.1472L0.0585 17.5722L11.4945 29.0435L0 40.5717L7.39313 48.0016L18.9113 36.4688L30.3664 47.918L37.7827 40.493L7.47375 10.1472Z",
    fill: "#53B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3466 29.0437L18.9111 36.4687L30.3663 47.9178L37.7826 40.4928L26.3466 29.0437Z",
    fill: "#119EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3466 29.0437L18.9111 36.4687L21.7735 39.315L26.3466 29.0437Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4822 18.9345L48.0003 7.40175L40.581 0L29.0673 11.5091L17.6092 0.0585L10.1943 7.48388L40.5018 37.8296L47.9182 30.4046L36.4822 18.9345Z",
    fill: "#53B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6303 18.9345L29.0658 11.5095L17.6092 0.0581055L10.1943 7.48386L21.6303 18.9345Z",
    fill: "#119EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6299 18.9346L29.0654 11.5096L26.203 8.66187L21.6299 18.9346Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitor);
export default __webpack_public_path__ + "static/media/capacitor.a022547a151c5eacc88ae7c644dd8319.svg";
export { ForwardRef as ReactComponent };